import * as React from "react";
import { TextInput, Button, Grid, Title, Card, Text, useMantineTheme } from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { UseCaseType } from "@supportinitiative/common";

import { escapeRegExp } from "../utilities";
import { useUseCases } from "../hooks";
import Loading from "../ui/Loading";
import { styles } from "../styles";

function getIsMatch(filter: string) {
  const isMatch = (useCase: UseCaseType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return re.test(useCase.name) || re.test(useCase.displayName) || re.test(useCase.description);
  };
  return isMatch;
}

export default function UseCases(props: { type?: string }) {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");

  let [filter, setFilter] = React.useState("");
  const { data: useCases, isLoading } = useUseCases(entityId, props.type);
  const theme = useMantineTheme();

  const filteredUseCases = useCases ? useCases.filter(getIsMatch(filter)) : [];

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>
        {props.type
          ? props.type === "MONITORING"
            ? "Monitoring"
            : props.type === "QUERYSET"
              ? "Queryset"
              : props.type === "RECONCILIATION"
                ? "Reconciliation"
                : "Usecases"
          : "Usecases"}
      </Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/${
              props.type
                ? props.type === "MONITORING"
                  ? "monitorings"
                  : props.type === "QUERYSET"
                    ? "querysets"
                    : props.type === "RECONCILIATION"
                      ? "reconciliations"
                      : "usecases"
                : "usecases"
            }/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredUseCases.length > 0 ? (
            <Grid align="center" gutter={"xs"} mb="xs">
              {filteredUseCases.map((useCase) => {
                return (
                  <Grid.Col span={3} key={useCase.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/usecases/view?id=${useCase.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="useCase"
                    >
                      <Text fw={500}>{useCase.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {useCase.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: theme.spacing.lg,
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No Usecases
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
